import { Routes } from '@angular/router';
import { AuthComponent } from './components/auth/auth.component';
import { StoresComponent } from './components/stores/stores.component';
import { StoreComponent } from './components/store/store';
import { ApiKeysComponent } from './components/api-keys/api-keys.component';
import { OauthComponent } from './components/oauth/oauth.component';
import { SlackOauthComponent } from './components/slack-oauth/slack-oauth.component';
import { GoogleAdsOauthComponent } from './components/google-ads-oauth/google-ads-oauth.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { ReportsComponent } from './components/reports/reports.component';
import { ChatComponent } from './components/chat/chat.component';
import { ChatHistoryComponent } from './components/chat-history/chat-history.component';
import { ChatClientsComponent } from './components/chat-clients/chat-clients.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/stores', pathMatch: 'full' },
  { path: 'auth', component: AuthComponent },
  { path: 'stores', component: StoresComponent, canActivate: [authGuard] },
  { path: 'store/:bot_id', component: StoreComponent, canActivate: [authGuard] },
  { path: 'api-keys/:bot_id', component: ApiKeysComponent, canActivate: [authGuard] },
  { path: 'reports/:bot_id', component: ReportsComponent, canActivate: [authGuard] },
  { path: 'chat/:bot_id', component: ChatComponent, canActivate: [authGuard] },
  { path: 'chat-clients/:bot_id', component: ChatClientsComponent, canActivate: [authGuard] },
  { path: 'chat/:bot_id/:user_id', component: ChatHistoryComponent, canActivate: [authGuard] },
  { path: 'authorize/shopify', component: OauthComponent, canActivate: [authGuard] },
  { path: 'authorize/slack', component: SlackOauthComponent, canActivate: [authGuard] },
  { path: 'auth/google-ads', component: GoogleAdsOauthComponent, canActivate: [authGuard] },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: '**', redirectTo: '/stores' }
];
